import React, { useEffect, useState } from "react";
import axios from "axios";
import CourseList from "./CourseList";

const CourseHome = ({ column, StyleVarProp }) => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedCourses = localStorage.getItem("courses");

        if (storedCourses) {
            setCourses(JSON.parse(storedCourses));
            setLoading(false);
        } else {
            axios
                .get(`${process.env.REACT_APP_API_BASE_URL}/courses`)
                .then((response) => {
                    setCourses(response.data.data);
                    localStorage.setItem("courses", JSON.stringify(response.data.data));
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Failed to fetch courses:", error);
                    setLoading(false);
                });
        }
    }, []);

    if (loading) {
        return <p>Loading courses...</p>;
    }

    return (
        <>
            {courses.length > 0 && (
                <>
                    <h3 className="section-title mb-4">All Courses</h3>
                    <div className="row row--15">
                        {courses.map((course) => (
                            <div key={course.id} className={column}>
                                <CourseList StyleVar={StyleVarProp} data={course} />
                            </div>
                        ))}
                    </div>
                </>
            )}
        </>
    );
};

export default CourseHome;
